import React from 'react'
import type { Translation } from '../../i18n'
import { serif, warm900, warm300, cream, stoneTwo } from './tokens'

type Props = { l: Translation['landing']['testemunhos'] }

export const TestemunhosSection: React.FC<Props> = ({ l }) => (
  <section className="px-10 md:px-20 py-24" style={{ background: warm900 }}>
    <p className="flex items-center gap-3 text-[0.75rem] font-medium tracking-[0.18em] uppercase mb-4" style={{ color: warm300 }}>
      <span className="w-6 h-px inline-block" style={{ background: warm300 }} />
      {l.sectionLabel}
    </p>
    <h2
      className="text-[clamp(2rem,3.5vw,3rem)] font-light leading-[1.15] mb-12"
      style={{ fontFamily: serif, color: cream }}
    >
      {l.title}
    </h2>
    <div className="grid md:grid-cols-3 gap-6">
      {l.items.map((item, i) => (
        <div key={i} className="rounded-[2px] p-8" style={{ border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.05)' }}>
          <div className="tracking-[0.1em] text-[0.9rem] mb-4" style={{ color: warm300 }}>★★★★★</div>
          <p className="italic font-light leading-[1.65] mb-5 text-[1.05rem]" style={{ fontFamily: serif, color: '#f5ece0' }}>
            {item.text}
          </p>
          <p className="text-[0.78rem] font-medium tracking-[0.1em] uppercase" style={{ color: stoneTwo }}>{item.author}</p>
        </div>
      ))}
    </div>
  </section>
)
